import * as Yup from 'yup'
import dayjs from 'dayjs'

Yup.addMethod(Yup.string, 'validateDate', function (errorMessage) {
  return this.test(`test-date`, errorMessage, function (value) {
    const { path, createError } = this

    if (!value) {
      return createError({ path, message: errorMessage })
    }

    const date = dayjs(value, 'MM/DD/YYYY', true)

    if (!date.isValid()) {
      return createError({ path, message: 'Date must be in MM/DD/YYYY format' })
    }

    if (date.isAfter(dayjs())) {
      return createError({ path, message: 'Date cannot be in the future' })
    }

    return true
  })
})

export const MCNumberSchema = Yup.object().shape({
  mcNumber: Yup.string().required('Motor Carrier Number is required'),
  lastSubmittedDate: Yup.string()
    .required('Last submitted date is required')
    // @ts-ignore
    .validateDate('Last submitted date is invalid'),
})
